import styled from "styled-components/macro";
import { Text } from "../../../../components";
import Action from "../../../../components/common/Action";
import { media, zIndexes } from "../../../../utils";

const getSelectLetter = ({ selected, theme }) =>
  selected
    ? `
color: ${theme.color.brandSecondary.light}; 
text-decoration: underline;
`
    : "";

export const CaptionText = styled(Text)`
  margin-bottom: 0;
`;

export const InputSearch = styled.div({
  maxWidth: "344px",
});

export const AlphabetLetter = styled(Action)`
  margin: 5px 18px;
  ${media.md()} {
    margin: 0px 12px;
  }

  ${getSelectLetter};
`;

export const AlphabetContent = styled.div`
  flex-wrap: wrap;
  display: flex;
  justify-content: center;
  margin: 1rem 0;
  ${media.md()} {
    justify-content: normal;
  }
`;

export const DetailsCardHeaderIcon = styled.svg({
  margin: "0 12px",
  fontSize: "1.3rem",
});
export const DetailsCardHeader = styled.a(({ theme }) => ({
  display: "flex",
  minHeight: "66px",
  justifyContent: "space-between",
  alignItems: "center",
  marginRight: "-12px",
  padding: "0",
  paddingTop: "12px",
  color: theme.color.brandPrimary.light,
  cursor: "pointer",
  "&:hover": {
    color: theme.color.brandPrimary.medium,
  },
}));

export const DetailsCardData = styled.div({
  paddingBottom: "16px 0px",
});

export const DetailsCard = styled.div(({ theme }) => ({
  padding: "0 16px",
  background: theme.color.neutral["08"],
  width: "100%",
  "& > .Card__Body": {
    height: "0",
    overflow: "hidden",
    borderBottom: `1px solid ${theme.color.neutral["04"]}`,
  },
  "&.active": {
    position: "absolute",
    zIndex: zIndexes.widget,
    "& > .Card__Header": {
      [`${DetailsCardHeader}`]: {
        color: theme.color.brandPrimary.medium,
        [`${DetailsCardHeaderIcon}`]: {
          transform: "rotate(-45deg)",
          transition: "transform 900ms ease",
        },
      },
    },
    "& > .Card__Body": {
      height: "auto",
      animatioName: "openDetaisItem",
      animationIterationCount: "1",
      animationTimingFunction: "ease-in",
      animationDuration: "300ms",
    },
  },
}));

export const Details = styled.div({
  width: "100%",
  position: "relative",
  [media.lg()]: {
    maxWidth: "calc(100% / 3)",
  },

  "@keyframes openDetaisItem": {
    "0%": {
      height: "0",
    },
    "100%": {
      height: "auto",
    },
  },

  "@keyframes closeDetaisItem": {
    "0%": {
      height: "auto",
    },
    "100%": {
      height: "0",
    },
  },
});

export const Accordion = styled.div(() => ({
  display: "flex",
  justifyContent: "space-between",
  flexWrap: "wrap",
}));
